import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { CustomButton, MobilePagination, Text } from '../../shared/uiComponents';
import { Loader } from '../../components/StyledComponents';
import MobileSort from '../../components/MobileSort';
import { AdminDataProperties } from './tableInfo';

import { DispatchProperties, useSelector } from '../../redux/store';
import { getBCBAs } from '../../redux/State/userSlice';
import { SelectDataProperties } from '../../shared/uiComponents/Dropdown';
import './styles.scss';
import { useCheckPermission } from '../../shared/Helpers/hooks';
import { PERMISSIONS } from '../../App/constants';
import { PlusIcon, SearchIcon } from '../../shared/Assets/svg';
import SearchBar from '../../components/SearchBar';
import { Users } from '../../shared/Assets/menuIcons';
import MobileViewClientItem from '../../components/MobileViewClientItem';
import { AdminTypes } from '../../components/Menu';

const sortData: SelectDataProperties[] = [
	{ id: 'fullName', name: 'Full Name' },
	{ id: 'numberOfClients', name: 'Number of Clients' },
	{ id: 'emailConfirmed', name: 'Email Status' },
	{ id: 'isDeactivated', name: 'Account Status' },
	{ id: 'authorizationType', name: 'Authorization Type' },
];

const MobileView: FC<AdminDataProperties> = (data) => {
	const { query, totalNumberOfItems } = data;
	const [params] = useSearchParams();

	const dispatch = useDispatch<DispatchProperties>();
	const { permissionGranted } = useCheckPermission(PERMISSIONS.USER.CREATE);
	const navigate = useNavigate();

	const [searchOpen, setSearchOpen] = useState(false);

	const loading = useSelector((state) => state.user.loading);

	const fetchUsers = () => {
		const page = params.get('page') || '1';
		const pageSize = params.get('pageSize') || '8';
		const orderBy = params.get('orderBy') || '';
		const direction = params.get('direction') || '';
		const searchString = params.get('search') || '';

		dispatch(getBCBAs({ page, pageSize, orderBy, direction, searchString }));
	};

	const addBcbaHandler = () => {
		window.localStorage.setItem('formType', AdminTypes[1]);
		navigate('/bcba/new');
	};

	return (
		<div className="mobileViewClientsContainer">
			<div className="mobileViewClientsContainerHeader">
				<div className="mobileViewClientsContainerTitle">
					<div className="mobileViewClientsContainerTitleIcon">
						<Users />
					</div>
					<Text title="BCBA" type="pmd" fontWeight="semiBold" />
				</div>
				<div className="mobileViewClientsContainerActions">
					<CustomButton
						buttonType="secondaryGray"
						iconOnly={<SearchIcon size={20} />}
						onClick={() => setSearchOpen((v) => !v)}
					/>
					{permissionGranted && <CustomButton title="Add BCBA" iconOnly={<PlusIcon />} onClick={addBcbaHandler} />}
				</div>
			</div>
			<div className={`mobileViewClientsContainerSearchExpander ${searchOpen ? 'open' : ''}`}>
				<SearchBar style={{ marginTop: 8 }} />
			</div>
			<MobileSort data={sortData} />
			{loading && <Loader />}
			{!loading && !totalNumberOfItems && (
				<div className="mobileViewClientsContainer">
					<Text title="No results" type="plg" fontWeight="semiBold" className="marginAuto" />
				</div>
			)}
			{!loading && query?.map((item) => <MobileViewClientItem data={item} fetchUsers={fetchUsers} key={item.id} />)}
			<MobilePagination data={data} />
		</div>
	);
};

export default MobileView;
